import { ApplicationStatus } from '@api/btlApplicationForm/types';

export const STATUS_TO_LABELS: Partial<Record<ApplicationStatus, string>> = {
  [ApplicationStatus.NEW]: 'New',
  [ApplicationStatus.DIP_SUBMITTED]: 'DIP Submitted',
  [ApplicationStatus.REVIEWING_DIP]: 'Reviewing DIP',
  [ApplicationStatus.DIP_ACCEPTED]: 'DIP Accepted',
  [ApplicationStatus.DIP_DECLINED]: 'DIP Declined',
  [ApplicationStatus.DIP_EXPIRED]: 'DIP Expired',
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: 'BTL Application Submitted',
  [ApplicationStatus.FIS_ISSUED]: 'FIS Issued',
  [ApplicationStatus.FEES_PAID]: 'Fees Paid',
  [ApplicationStatus.REVIEWING_APPLICATION]: 'Reviewing Application',
  [ApplicationStatus.OFFER_ISSUED]: 'Offer Issued',
  [ApplicationStatus.OFFER_ACCEPTED]: 'Offer Accepted',
  [ApplicationStatus.OFFER_EXPIRED]: 'Offer Expired',
  [ApplicationStatus.APPLICATION_DECLINED]: 'Application Declined',
  [ApplicationStatus.COMPLETION]: 'Completion',
};

export const STATUS_TO_CAN_RUN_AFFORDABILITY: Partial<Record<ApplicationStatus, boolean>> = {
  [ApplicationStatus.NEW]: true,
  [ApplicationStatus.DIP_SUBMITTED]: false,
  [ApplicationStatus.REVIEWING_DIP]: false,
  [ApplicationStatus.DIP_ACCEPTED]: true,
  [ApplicationStatus.DIP_DECLINED]: false,
  [ApplicationStatus.DIP_EXPIRED]: false,
  [ApplicationStatus.APPLICATION_SUBMITTED]: true,
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: true,
  [ApplicationStatus.FIS_ISSUED]: false,
  [ApplicationStatus.FEES_PAID]: false,
  [ApplicationStatus.REVIEWING_APPLICATION]: false,
  [ApplicationStatus.OFFER_ISSUED]: false,
  [ApplicationStatus.OFFER_ACCEPTED]: false,
  [ApplicationStatus.OFFER_EXPIRED]: false,
  [ApplicationStatus.APPLICATION_DECLINED]: false,
  [ApplicationStatus.COMPLETION]: false,
};

export const isDipAcceptedOrLater = (status?: ApplicationStatus): boolean => {
  if (!status) return false;

  const statusesDipAcceptedAndAfter: ApplicationStatus[] = [
    ApplicationStatus.DIP_ACCEPTED,
    ApplicationStatus.AWAITING_PROPERTY,
    ApplicationStatus.PROPERTY_SUBMITTED,
    ApplicationStatus.BOOKING_PRE_ADVICE,
    ApplicationStatus.PRE_ADVICE_BOOKED,
    ApplicationStatus.ADVICE_BOOKED,
    ApplicationStatus.PRODUCT_NOT_SUITABLE,
    ApplicationStatus.RECOMMENDED,
    ApplicationStatus.FIS_ISSUED,
    ApplicationStatus.PAYMENT_DUE,
    ApplicationStatus.APPLICATION_SUBMITTED,
    ApplicationStatus.BTL_APPLICATION_SUBMITTED,
    ApplicationStatus.FEES_PAID,
    ApplicationStatus.REVIEWING_APPLICATION,
    ApplicationStatus.PROPERTY_DECLINED,
    ApplicationStatus.APPLICATION_DECLINED,
    ApplicationStatus.OFFER_ISSUED,
    ApplicationStatus.OFFER_ACCEPTED,
    ApplicationStatus.OFFER_EXPIRED,
    ApplicationStatus.OFFER_BEING_REVISED,
    ApplicationStatus.COMPLETION,
  ];

  return statusesDipAcceptedAndAfter.includes(status);
};

export function shouldShowFullBtlApplicationAssertions(status?: ApplicationStatus): boolean {
  if (!status) {
    return false;
  }

  if (status === ApplicationStatus.DIP_DECLINED || status === ApplicationStatus.DIP_EXPIRED) {
    return true;
  }

  return isDipAcceptedOrLater(status);
}
